import React from 'react';
import Head from 'next/head';
import BaseLayout from '../layouts/BaseLayout.jsx';
import MatterScene from '../components/MatterScene2';
import IconCollections from '../components/CollectionBanners2.jsx';
import FAQ from '../components/FAQ.jsx';
import { getServerSideAuth } from '../utils/serverSideAuth';

// Добавляем конфигурацию Edge Runtime
export const runtime = 'experimental-edge';

const HomePage = ({ serverAuthState }) => {
  return (
    <>
      <Head>
        <link rel="canonical" href="https://davooda.com" />
      </Head>
      
      <BaseLayout
        title="Davooda's Icons Shop."
        description="Beautiful Icons for web-design, application, design and more."
        showHeader={true}
        serverAuthState={serverAuthState}
      >
        <div>
          <IconCollections />
          <MatterScene />
          {/* <FAQ /> */}
        </div>
      </BaseLayout>
    </>
  );
};

// Добавляем серверную проверку авторизации
export async function getServerSideProps(context) {
  // Получаем состояние авторизации с сервера
  const serverAuthState = await getServerSideAuth(context);
  
  return {
    props: {
      serverAuthState,
    },
  };
}

export default HomePage;